class StyledSelect extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['select', 'value']
  }

  setupListeners () {
    super.setupListeners()

    const selectEl = this.els?.select?.element

    if (!selectEl) return

    this.listeners.add(selectEl, 'change', this.handleSelect.bind(this))
  }

  handleSelect (event) {
    const selectEl = event.target
    const valueEl = this.els?.value?.element

    if (!valueEl) return

    valueEl.textContent = selectEl.options[selectEl.selectedIndex].text
  }
}

customElements.define('styled-select', StyledSelect)
